import type { MetricEventUrlKind } from '@gonfalon/metrics/types';

export const urlMatcherKindDisplayNames: Record<MetricEventUrlKind, string> = {
  canonical: 'Simple match',
  exact: 'Exact match',
  regex: 'Regular expression',
  substring: 'Substring match',
};

export function isAbsoluteUrl(url: string) {
  return /^(?:\w+:)?\/\//.test(url.toString());
}

export interface MetricUrlAccessDecision {
  isAllowed: boolean;
  getModifyFieldReason(): string;
}

export function allowDecision(): MetricUrlAccessDecision {
  return {
    isAllowed: true,
    getModifyFieldReason() {
      return '';
    },
  };
}
